<template>
  <div class="spl-problem-report-footer">
    <div class="row">
      <div class="col4">
        <form-label :dark="true">
          Send additional email to
        </form-label>
        <form-input
          name="email"
          placeholder="Enter your email address here"
          validate-email="true" />
      </div>
      <div class="col8">
        <form-button :extrapadding="true">
          Export to Excel
        </form-button>
        <form-button :extrapadding="true">
          Export to HTML
        </form-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProblemReportFooter'
}
</script>

<style lang="scss">
    @import '../../variables.scss';

    .spl-problem-report-footer {
        background-color: $middleYellow;
        bottom: 0;
        border-top: 3px solid #fff;
        padding: 45px $mainPadding 60px $mainPadding;
        position: fixed;
        width: 100%;

        .spl-input {
            margin-bottom: 0;
        }
        .spl-button {
            background-color: $mainInputColor;
            color: $footerButtonDarkGreyText;
            float: right;
            margin-bottom: 0;
            margin-top: 25px;

            &-secondary {
                background-color: $footerButtonYellow;
                color: $yellowButtonLabel;
            }
        }
    }
</style>
